function emailIsValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
function kolonaHeroSection() {
  const block = document.getElementById('kolona-hero');
  const form = document.getElementById('auto-subscription-form');
  const input = document.getElementById('kolona-form-input-email');
  const error = document.getElementById('kolona-form-input-email-error');
  const amount = document.getElementById('kolona-form-input-amount');
  if (block && form) {
    const links = block.querySelectorAll('.js-kolona-form-link');
    links.forEach((link) => {
      link.addEventListener('click', () => {
        links.forEach((l) => {
          if (l.classList.contains('active')) {
            l.classList.remove('active');
          }
        });
        link.classList.add('active');
        amount.value = link.dataset.amount;
      });
    });

    const shakeTrigger = block.querySelector('.js-kolona-participant-form-trigger');
    const formContainer = block.querySelector('.js-kolona-form');
    if (shakeTrigger && formContainer) {
      shakeTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (!shakeTrigger.classList.contains('active')) {
          shakeTrigger.classList.add('active');
          formContainer.classList.add('ahashakeheartache');
          setTimeout(() => {
            formContainer.classList.remove('ahashakeheartache');
            shakeTrigger.classList.remove('active');
          }, 400);
        }
      });
    }

    form.addEventListener('submit', (e) => {
      const errors = [
        'Це поле потрібно заповнити',
        'email введено не корректно',
        'Твій імейл важливий. Перевір про всяк',
      ];
      if (input.value === '') {
        e.preventDefault();
        input.classList.add('error');
        error.classList.add('error');
        error.innerHTML = errors[0];
      } else if (!emailIsValid(input.value)) {
        e.preventDefault();
        input.classList.add('error');
        error.classList.add('error');
        error.innerHTML = errors[1];
      } else {
        input.classList.remove('error');
        error.classList.remove('error');
        error.innerHTML = errors[2];
      }
    });

    input.addEventListener('input', (e) => {
      if (e.target.classList.contains('error')) {
        e.target.classList.remove('error');
        error.classList.remove('error');
      }
    });
  }
}

export default kolonaHeroSection;
